import React from "react";
import cover from '../asset/pantai.jpg';

const Hero = () =>  {
    return(
        <section className="bg-cover bg-center h-screen text-white"
        style={{ backgroundImage :`url(${cover})`}}
        >
            <div className="bg-black opacity-60  h-full flex flex-col justify-center items-center text-center p-6 " >
                <div className="flex flex-col justify-between items-center space-x-2 mb-4">
                    <h4 className="text-5xl font-bold mb-4">Hallo, I'm Tafazzul Reza A</h4> 
                    
                <h2 className="text-5xl  font-semibold mb-4">KIDI Intern</h2>
                </div>
               

               <a href="#contact" className="bg-yellow-950 hover:bg-yellow-950 text-white font-bold py-2 px-6 rounded-lg shadow-lg transition duration-300" > 
                Contact
               </a>
            </div>
        </section>                                                          
    )
}                                                    

export default Hero;